import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserDetails from './components/UserDetails/UserDetails';
import CreateRequest from './components/CreateRequest/CreateRequest';
import ViewRequest from './components/ViewRequest/ViewRequest';
import {Route, Switch} from 'react-router-dom';
import Layout from './components/Layout/Layout';
import UserContext from './context/user-context';

class App extends Component {
  setUserDetails = userDetails => {
    this.setState({accountNumber: userDetails.accountNumber});
    this.setState({streetNumber: userDetails.streetNumber});
    this.setState({streetName: userDetails.streetName});
    this.setState({streetType: userDetails.streetType});
    this.setState({unitNumber: userDetails.unitNumber});
    this.setState({locationId: userDetails.locationId});
    this.setState({fullAddress: userDetails.fullAddress});
    this.setState({requestType: userDetails.requestType});
    this.setState({isAuthenticated: true});
  }

  setSFToken = token => {
      this.setState({token: token});
  }

  state = {
    accountNumber:"",
     streetNumber:"",
     streetName: "",
     streetType: "",
     unitNumber:"",
     locationId:"",
     token:"",
     fullAddress:"",
     requestType: [],
     isAuthenticated:false,
    setUserDetails: this.setUserDetails,
    setSFToken: this.setSFToken
  }

  render() {
    return ( 
      <UserContext.Provider
      value={this.state}>
      <div>
        <Layout>
         {
           <Switch>
             <Route path ="/" exact component ={UserDetails} />
             <Route path ="/create-request" component ={CreateRequest}/>
             <Route path ="/view-request" component = {ViewRequest} />
           </Switch>
         }
        </Layout>
   </div>
   </UserContext.Provider>
    );
  }
}

export default App;
